// Copyright ©️ 2026 eVolve MEP, LLC

import { isNil } from 'helpers/isNotNil';
import {
  BendPreviewGeometry,
  type BendPreviewSpecifications,
} from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendPreviewGeometry';
import type { BendDefLabel } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/buildLabelOpts';

export class BendLayoutGeometry extends BendPreviewGeometry {
  createBendDefs(dimensions: BendPreviewSpecifications) {
    if (isNil(dimensions.layoutDimensions)) throw new Error('Layout dimensions missing');
    const { marks, overallLength } = dimensions.layoutDimensions;
    return [
      {
        runLength: overallLength,
        startLabels: marks
          .map((mark, i, arr): BendDefLabel => ({
            label: mark.label,
            length: mark.value,
            preferredDistance: 0.1 + (i / arr.length) * 0.5,
          }))
          .concat([
            { label: 'Overall Length', length: overallLength, preferredDistance: 0.2, directionPreference: 'inward' },
          ]),
      },
    ];
  }
}
